import { createUseStyles } from 'react-jss'

const features = [
    {
        title: 'ضمانت کیفیت',
        description: ' تمام کالاهای موجود در کاج استور از بالاترین کیفیت نسبت به نمونه های مشابه داخل بازار برخوردارند',
        pic_path: '/img/icons/svg/063-like.svg'
    },
    {
        title: ' ارسال و تحویل اکسپرس',
        description:
            'سفارشات شما طبق شرایط زیر پس از گذشت 24 ساعت کاری تحویل خواهند سفارشات ثبت شده در کمترین زمان ممکن به دست مشتری میرسد.',
        pic_path: '/img/icons/svg/081-box.svg'
    },
    {
        title: 'ضمانت سلامت کالا',
        description: 'تمام سفارشات قبل از ارسال و بسته بندی از نظر سلامت بررسی و تایید میشوند.',
        pic_path: '/img/icons/svg/092-shield.svg'
    }
]

const useStyles = createUseStyles({
    fImg: {
        maxWidth: '160px',
        margin: '0 auto'
    },
    fTextBox: {
        alignSelf: 'center'
    }
})

export function ShopFeatures() {
    
    const classes = useStyles()

    return features.map((item, idx) => (
        <div key={idx} className="text-justify grid grid-cols-3 rounded-xl featureItem">
            <div className={`${classes.fImg} p-6`}>
                <img className="w-full" src={item.pic_path} />
            </div>
            <div className={`${classes.fTextBox} col-start-2 col-end-4`}>
                <h3 className="mb-3 text-xl">{item.title}</h3>
                <p>{item.description}</p>
            </div>
        </div>
    ))
}
